import { useEffect, useState } from "react";
import {
  resetDollhouseMap,
  getMapSourceDestinationPaths,
  resetAllMapPathSvg,
  getSourceSelectedAria,
  getDestinationSelectedAria,
} from "./customEvents.js";
import SvgElement from "./SvgElement";
import { useStoreDollHouseMap } from "../store";
import { shallow } from "zustand/shallow";

export default function Floormapsvg({
  renderViewType,
  isExploreareaView,
  dollhouseImages,
  transformComponentRef,
}) {
  const [svgpathsVisibility, setSvgPathVisibility] = useState(false);
  const [routeResponse, setRouteResponse] = useState(null);

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      isRouteSubmitted: state.isRouteSubmitted,
      sourceAreaSelected: state.sourceAreaSelected,
      destinationAreaSelected: state.destinationAreaSelected,
      routeTypeSelected: state.routeTypeSelected,
      setsubmitFindRoute: state.setsubmitFindRoute,
      updatePOIPointAreaSelection: state.updatePOIPointAreaSelection,
      changePopupvisibility: state.changePopupvisibility,
      updateSvgRoutePathVisibility: state.updateSvgRoutePathVisibility,
    }),
    shallow
  );
  //User Submit For DIrection Path
  useEffect(() => {
    // // console.log("mapRenderDatas-------", mapRenderDatas);
    // if (mapRenderDatas) {
    //   console.log(mapRenderDatas);
    //   _showRoutePathBuildings();
    // }

    // console.log(dollhouseStore.sourceAreaSelected);

    // console.log(dollhouseStore.destinationAreaSelected);

    if (dollhouseStore.isRouteSubmitted) {
      let sourcearea = getSourceSelectedAria(dollhouseStore.sourceAreaSelected);
      let destinationarea = getDestinationSelectedAria(
        dollhouseStore.destinationAreaSelected
      );

      if (sourcearea !== null) {
        dollhouseStore.updatePOIPointAreaSelection(sourcearea);
      }

      if (destinationarea !== null) {
        dollhouseStore.updatePOIPointAreaSelection(destinationarea);
      }

      _showRoutePathBuildings(destinationarea.poiId, sourcearea.poiId);
      dollhouseStore.setsubmitFindRoute(false);
    }
  }, [dollhouseStore.isRouteSubmitted]);

  useEffect(() => {
    if (renderViewType === "ISOMETRIC_VIEW") {
      resetDollhouseMap();
    }
  }, [renderViewType]);

  useEffect(() => {
    if (isExploreareaView) {
      const elements = document.querySelectorAll(".hotspt");
      elements.forEach((element) => {
        element.classList.add("hotspt_evnt");
      });
    } else {
      const elements = document.querySelectorAll(".hotspt");
      elements.forEach((element) => {
        element.classList.remove("hotspt_evnt");
      });
    }
  }, [isExploreareaView]);

  //checking When User Change Builind Map user selected any start and end destination

  const _showRoutePathBuildings = (destination, source) => {
    resetAllMapPathSvg();

    let filterResponse = null;
    getMapSourceDestinationPaths().then((response) => {
      filterResponse = response.filter((val) => {
        return val.source === source && val.destination === destination;
      });

      console.log(filterResponse);

      if (filterResponse.length > 0) {
        dollhouseStore.updateSvgRoutePathVisibility(true);
        setRouteResponse(filterResponse);
      } else {
        dollhouseStore.updateSvgRoutePathVisibility(false);
        setRouteResponse(null);

        dollhouseStore.changePopupvisibility(true, "No route exists.");
      }
    });
  };

  return (
    <>
      <SvgElement
        routeResponse={routeResponse}
        dollhouseImages={dollhouseImages}
        transformComponentRef={transformComponentRef}
      />
    </>
  );
}
